import { render, staticRenderFns } from "./change-data-diff.vue?vue&type=template&id=6aa1fde2&scoped=true"
import script from "./change-data-diff.vue?vue&type=script&lang=ts"
export * from "./change-data-diff.vue?vue&type=script&lang=ts"
import style0 from "./change-data-diff.vue?vue&type=style&index=0&id=6aa1fde2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1fde2",
  null
  
)

export default component.exports